module.exports = __webpack_public_path__ + "img/vmc_aniv23_24Aug2021.df12cb47.jpg";